<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Lista de Solicitações'"
      :tableHeader="headers"
      :tableRows="solicitacoes"
      :isStatus="true"
      :isDel="true"
      :totalItens="total"
      v-on:datatable-updatestatusrow="updateStatusSolicitacao"
      v-on:datatable-deleterow="onDataTableDeleteRow"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable v-show="showSkeletonTable == true" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="updateStatusOfSolicitacao"
    >
      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>

          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.actualEdit.descricaoSolicitacaoItem" name="descricaoSolicitacaoItem" label="Descrição da Solicitação" readonly></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.actualEdit.dataSolicitacaoItem" name="dataSolicitacaoItem" label="Data da Solicitação" readonly></v-text-field>
          </v-col>

          <!-- #region Ultimas Solicitações -->
          <v-expand-transition>
            <v-col v-if="ultimasSolicitacoes.length > 0" cols="12">
              <v-row>
                <v-col cols="12">
                  <v-subheader>Últimas Solicitações</v-subheader>
                  <v-divider />

                  <v-list>
                    <v-list-group v-for="(solicitacao, i) in ultimasSolicitacoes" :key="i" no-action>
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title>{{ 'Solicitação: ' + solicitacao.solicitarItem.numeroSolicitacaoItem + ' - ' + solicitacao.solicitarItem.descricaoSolicitarItem + ' | ' + _formatStringInBrazilianDateFormat(solicitacao.solicitarItem.dataSolicitarItem) }}</v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <v-list-item-content>
                        <v-row cols="12" align="center">
                          <v-col cols="12">
                            <v-card class="ma-4">
                              <v-data-table :headers="headersItensSolicitadosSemCampoExcluir" :items="solicitacao.itensSolicitados">
                                <template v-slot:top>
                                  <v-toolbar flat color="white">
                                    <v-toolbar-title>Produtos Solicitados</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                  </v-toolbar>
                                </template>

                                <template v-slot:[`item.quantidadeEstoque`]="{ item }">
                                  {{ formatarQuantidade(item.quantidadeEstoque) }}
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-col>
          </v-expand-transition>
          <!-- #endregion -->

          <v-col cols="12">
            <v-autocomplete label="Lista de Produtos" :items="listOfItens" v-model="itemSelecionado"> </v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-text-field v-model="searchTableItens" append-icon="mdi-magnify" label="Buscar" single-line></v-text-field>
              </v-card-title>

              <v-data-table :headers="headersItensSolicitados" :search="searchTableItens" :items="modalCustomSize.actualEdit.listaDeItensSolicitados" disable-sort>
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Produtos Solicitados</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:[`item.nomeItemSistema`]="props">
                  <v-chip :color="verifyIfExist(props.item.nomeItemSistema, ultimasSolicitacoes)" dark>
                    {{ props.item.nomeItemSistema }}
                  </v-chip>
                </template>

                <template v-slot:[`item.quantidadeEstoque`]="{ item }">
                  {{ formatarQuantidade(item.quantidadeEstoque) }}
                </template>

                <template v-slot:[`item.quantidadeSolicitada`]="props">
                  <v-text-field style="max-width:250px" v-model="props.item.quantidadeSolicitada" :rules="[rules.required]" label="Quantidade Solicitada" single-line @keypress="(event) => filter(event)"></v-text-field>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small class="mr-2" @click="modalUltimasDispensas(item)" v-bind="attrs" v-on="on">
                        mdi-eye
                      </v-icon>
                    </template>
                    <span>Visualizar saída mensal</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small @click="deleteItemFromList(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-textarea v-model="modalCustomSize.actualEdit.observacaoSolicitacao" name="descricaoObservacao" label="Observação de Solicitação" rows="3" row-height="20" />
          </v-col>

          <v-col cols="12">
            <v-autocomplete label="Status" :items="listOfStatus" v-model="modalCustomSize.actualEdit.indicadorStatusSolicitarItem"> </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>

      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" text @click="snack = false">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </ModalCustomSize>

    <ModalCustomSize
      :isTheModalOpen="modalCustomSizeUlimasDispensas.isOpen"
      :modalButtonText="modalCustomSizeUlimasDispensas.buttonText"
      :modalFormTitle="modalCustomSizeUlimasDispensas.formTitle"
      :modalType="modalCustomSizeUlimasDispensas.modalType"
      :modalSize="'600px'"
      :isModalButtonVisible="modalCustomSizeUlimasDispensas.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSizeUlimasDispensas.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSizeUlimasDispensas.isOpen = false"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>
      </v-row>

      <v-row class="pa-0">
        <v-col cols="12" class="pa-0">
          <v-data-table :headers="verificaUnidade(modalCustomSize.actualEdit.numeroEndereco) ? headerUltimasDispensasZSaude : headerUltimasDispensas" :search="searchUltimasDispensas" :items="modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas" hide-default-footer>
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Totais Dispensados</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:[`item.mes`]="{ item }">
              {{ formataMes(item.mes) }}
            </template>

            <template v-slot:[`item.quantidadeTotalProcesso`]="{ item }">
              {{ item.quantidadeTotalProcesso.toFixed(2) }}
            </template>

            <template v-slot:[`item.quantidadeTotalUnidade`]="{ item }">
              {{ item.quantidadeTotalUnidade.toFixed(2) }}
            </template>

            <template v-slot:[`item.quantidadeTotal`]="{ item }">
              {{ verificaUnidade($store.state.numeroEndereco) ? item.quantidadeTotal.toFixed(2) : item.quantidadeTotal }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </ModalCustomSize>

    <DeleteItemModal :textModalDelete="modalDelete.textModalDelete" :showModalDelete="modalDelete.closeModal" :buttomTextModalDelete="'Excluir'" v-on:on-response-modal-delete="deleteSolicitacao" v-on:close-modal="modalDelete.closeModal = false"></DeleteItemModal>
  </v-col>
</template>

<script>
import DataTable from "@/components/DatatableSolicitacoes.vue";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import axios from "../plugins/axios";
import axiosZSaude from "../plugins/axios_integracao";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import DeleteItemModal from "../components/DeleteItemModal";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal,
    DeleteItemModal,
  },

  sockets: {
    reciveInsertUnidade: function(data) {
      if (data && data.descricaoTela == "SolicitarItem") {
        this.alertaSocket.tipo = "info";
        this.alertaSocket.texto = "Nova Solicitação emitida, nome da solicitação: " + data.descricaoSolicitarItem;
        this.initialize();
      }
    },

    reciveUpdateUnidade: function(data) {
      if (data && data.descricaoTela == "SolicitarItem") {
        this.alertaSocket.tipo = "info";
        this.alertaSocket.texto = "Solicitação: " + data.numeroSolicitarItem + " - " + data.descricaoSolicitarItem + " foi atualizada!";
        this.initialize();
      }
    },

    reciveDeleteUnidade: function(data) {
      if (data && data.descricaoTela == "SolicitarItem") {
        this.alertaSocket.tipo = "info";
        this.alertaSocket.texto = "Solicitação: " + data.solicitarItem.numeroSolicitacaoItem + " - " + data.solicitarItem.descricaoSolicitarItem + " da unidade " + data.endereco.nomeEndereco + " foi deletada!";
        this.initialize();
      }
    },
  },

  data: () => ({
    //Paginação
    page: 1,
    search: null,
    total: null,
    searchUltimasDispensas: null,
    //Fim da paginação
    snack: false,
    snackColor: "",
    snackText: "",
    pagination: {},

    rules: {
      required: (value) => !!value || "Requer o campo!",
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    loading: false,
    showSkeletonTable: true,
    isFormValid: false,
    searchTableItens: "",

    //#region Headers tables
    headers: [
      {
        text: "ID",
        value: "solicitarItem.numeroSolicitacaoItem",
      },
      {
        text: "Descrição da Solicitação",
        value: "solicitarItem.descricaoSolicitarItem",
      },
      {
        text: "Data da Solicitação",
        value: "solicitarItem.dataSolicitarItem",
      },
      {
        text: "Nome da Unidade",
        value: "endereco.nomeEndereco",
      },
      {
        text: "Responsável pela Unidade",
        value: "endereco.nomeResponsavel",
      },
      {
        text: "Qtde. Produtos",
        value: "solicitarItem.quantidadeSolicitarItem",
      },
      {
        text: "Status da Solicitação",
        value: "solicitarItem.indicadorStatusSolicitarItem",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensSolicitados: [
      {
        text: "ID",
        value: "numeroItemSolicitar",
      },
      {
        text: "Nome do Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Qt. Estoque",
        value: "quantidadeEstoque",
      },
      {
        text: "Qt. Solicitada (Digite abaixo)",
        value: "quantidadeSolicitada",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headerUltimasDispensas: [
      {
        text: "Mês",
        value: "mes",
      },
      {
        text: "Total por Paciente",
        value: "quantidadeTotalPaciente",
      },
      {
        text: "Total por Setor",
        value: "quantidadeTotalSetor",
      },
      {
        text: "Total",
        value: "quantidadeTotal",
      }
    ],

    headerUltimasDispensasZSaude: [
      {
        text: "Mês",
        value: "mes",
      },
      {
        text: "Total Procedimento",
        value: "quantidadeTotalProcesso",
      },
      {
        text: "Total Unidade",
        value: "quantidadeTotalUnidade",
      },
      {
        text: "Total",
        value: "quantidadeTotal",
      },
    ],

    headersItensSolicitadosSemCampoExcluir: [
      {
        text: "ID",
        value: "numeroItemSolicitar",
      },
      {
        text: "Nome do Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Qt. Estoque",
        value: "quantidadeEstoque",
      },
      {
        text: "Qt. Solicitada",
        value: "quantidadeSolicitada",
      },
    ],
    //#endregion

    modalCustomSize: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsDisabled: false,
      isButtonsVisible: true,
      actualEdit: {
        numeroEndereco: null,
        numeroSolicitarItem: null,
        descricaoSolicitacaoItem: null,
        dataSolicitacaoItem: null,
        quantidadeSolicitacaoItem: null,
        indicadorStatusSolicitarItem: null,
        observacaoSolicitacao: null,
        listaDeItensSolicitados: [],
        listaDeItensRemovidos: [],
        descricaoTela: "solicitacaoDeItens",
      },
    },

    modalCustomSizeUlimasDispensas: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsDisabled: false,
      isButtonsVisible: false,
      actualEdit: {
        ultimasDispensas: [],
      },
    },

    modalDelete: {
      solicitacaoSelecionada: null,
      closeModal: null,
      textModalDelete: "Você realmente deseja deletar essa Solicitação de Produto?",
      descricaoTela: "SolicitarItem",
    },

    ultimasSolicitacoes: [],
    itensRelacionados: [],

    solicitacoes: [],
    listOfStatus: [
      {
        text: "Aguardando aprovação",
        value: 0,
      },
      {
        text: "Em processo de compras",
        value: 1,
      },
      {
        text: "Comprado",
        value: 2,
      },
      {
        text: "Recusado",
        value: 3,
      },
    ],
    listOfItens: [],
    itemSelecionado: null,
  }),

  created() {
    this.initialize();
  },

  watch: {
    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },

    itemSelecionado() {
      if (this.itemSelecionado) {
        this.alertaModal.tipo = "";

        const verificarItem = this.modalCustomSize.actualEdit.listaDeItensSolicitados.filter((item) => item.numeroItemSistemaUnidade == this.itemSelecionado);

        if (verificarItem.length <= 0) {
          const itemInsert = this.listOfItens.filter((item) => item.numeroItemSistemaUnidade == this.itemSelecionado);

          this.modalCustomSize.actualEdit.listaDeItensSolicitados.unshift({
            numeroItemSistema: itemInsert[0].numeroItemSistema,
            numeroItemSistemaUnidade: itemInsert[0].numeroItemSistemaUnidade,
            nomeItemSistema: itemInsert[0].text,
            quantidadeEstoque: itemInsert[0].quantidadeEstoque,
          });

          this.modalCustomSize.isButtonsDisabled = true;
          this.itemSelecionado = "";
        } else {
          this.alertaModal.tipo = "erro";
          this.alertaModal.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
        }
      }
    },
  },

  methods: {
    async initialize() {
      this.showSkeletonTable = true;
      try {
        await this.listaSolicitacoes();
      } catch (error) {
        console.log(error);
      }
    },

    async listaSolicitacoes() {
      try {
        let listSolicitacoes = await axios.put("listaDeSolicitacoes", { page: this.page, search: this.search, indicadorTipo: 0 }, this.config);
        this.solicitacoes = listSolicitacoes.data;
        this.total = listSolicitacoes.data[0].solicitarItem.total;
        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async updateSearch(search) {
      if (search) {
        this.search = search;
        this.page = 1;
        await this.listaSolicitacoes();
      } else {
        this.page = 1;
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page;
      await this.listaSolicitacoes();
    },

    async recoverListOfItens(numeroEndereco) {
      try {
        const responseItens = await axios.put("itemSistemaUnidade", { numeroEndereco: numeroEndereco }, this.config);

        this.listOfItens = responseItens.data.map((row) => {
          return {
            value: row.itemSistemaUnidade.numeroItemSistemaUnidade,
            text: row.itemSistema.nomeItemSistema,
            numeroItemSistema: row.itemSistema.numeroItemSistema,
            numeroItemSistemaUnidade: row.itemSistemaUnidade.numeroItemSistemaUnidade,
            quantidadeEstoque: row.quantidadeEstoqueTotal,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async listaUltimasDispensasProduto(numeroItemSistemaUnidade, numeroEndereco) {
      try {
        const response = await axios.put("totalultimasdispensas", { numeroItemSistemaUnidade: numeroItemSistemaUnidade, numeroEndereco: numeroEndereco }, this.config);
        return response.data;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },

    async listaUltimasDispensasProdutoZSaude(numeroUnidade, nomeProduto) {
      try {
        const response = await axiosZSaude.put("ultimasdispensas", { numeroUnidade: numeroUnidade, nomeProduto: nomeProduto  }, this.config);
        return response.data;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },

    async updateStatusOfSolicitacao() {
      try {
        if (this.modalCustomSize.actualEdit.listaDeItensSolicitados.length > 0) {
          this.alertaModal.tipo = "";
          await axios.put("solicitarItem", this.modalCustomSize.actualEdit, this.config);
          
          this.modalCustomSize.isOpen = false;
          this.showSkeletonTable = true;
          this.initialize();
        } else {
          this.alertaModal.texto = "Não foi possivel fazer a inserção, adicione produtos antes de fazer a Solicitação!";
          this.alertaModal.tipo = "erro";
          this.modalCustomSize.isButtonsDisabled = false;
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.modalCustomSize.isOpen = true;
        this.modalCustomSize.isButtonsDisabled = false;
      }
    },

    async deleteSolicitacao() {
      try {
        await axios.delete("solicitarItem", {
          data: this.modalDelete.solicitacaoSelecionada,
          headers: this.config.headers,
        });

        this.alerta.texto = "Solicitação removida com sucesso!";
        this.alerta.tipo = "sucesso";
      } catch (error) {
        console.log(error);
        this.alerta.texto = "Não foi possivel remover esta Solicitação.";
        this.alerta.tipo = "erro";
      } finally {
        this.modalDelete.closeModal = false;
        this.initialize();
      }
    },

    async updateStatusSolicitacao(solicitacaoSelecionada) {
      this.loading = true;
      try {
        let responseLatest = await axios.put("listaDeUltimasSolicitacoes", { numeroEndereco: solicitacaoSelecionada.endereco.numeroEnderecoOrdemServico, numeroSolicitacao: solicitacaoSelecionada.solicitarItem.numeroSolicitacaoItem, limite: 3, indicadorTipo: 0 }, this.config);
        this.ultimasSolicitacoes = responseLatest.data;

        this.recoverListOfItens(solicitacaoSelecionada.endereco.numeroEnderecoOrdemServico);

        let responseItens = await axios.put("itensSolicitar", { numeroSolicitarItem: solicitacaoSelecionada.solicitarItem.numeroSolicitacaoItem }, this.config);
        
        this.modalCustomSize.actualEdit.listaDeItensSolicitados = responseItens.data;

        this.searchTableItens = "";
        this.modalCustomSize.actualEdit.numeroEndereco = solicitacaoSelecionada.endereco.numeroEnderecoOrdemServico;
        this.modalCustomSize.actualEdit.numeroSolicitarItem = solicitacaoSelecionada.solicitarItem.numeroSolicitacaoItem;
        this.modalCustomSize.actualEdit.descricaoSolicitacaoItem = solicitacaoSelecionada.solicitarItem.descricaoSolicitarItem;
        this.modalCustomSize.actualEdit.dataSolicitacaoItem = this._formatStringInBrazilianDateFormat(solicitacaoSelecionada.solicitarItem.dataSolicitarItem);
        this.modalCustomSize.actualEdit.indicadorStatusSolicitarItem = solicitacaoSelecionada.solicitarItem.indicadorStatusSolicitarItem;
        this.modalCustomSize.actualEdit.observacaoSolicitacao = solicitacaoSelecionada.solicitarItem.observacaoSolicitarItem;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.buttonText = "Concluir";
        this.modalCustomSize.formTitle = "Atualizar Status";
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalUltimasDispensas(produtoSelecionado) {
      this.loading = true;
      try {
        if(this.verificaUnidade(this.modalCustomSize.actualEdit.numeroEndereco)) {
          this.modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas = [];
          this.modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas = await this.listaUltimasDispensasProdutoZSaude(this.retornaNumeroUnidadeZSaude(this.modalCustomSize.actualEdit.numeroEndereco), produtoSelecionado.nomeItemSistema);
        } else {
          this.modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas = [];
          this.modalCustomSizeUlimasDispensas.actualEdit.ultimasDispensas = await this.listaUltimasDispensasProduto(produtoSelecionado.numeroItemSistemaUnidade, this.modalCustomSize.actualEdit.numeroEndereco);
        }

      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSizeUlimasDispensas.isEdit = true;
        this.modalCustomSizeUlimasDispensas.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSizeUlimasDispensas.formTitle = "Últimas dispensas";
        this.modalCustomSizeUlimasDispensas.isOpen = true;
        this.loading = false;
      }
    },

    onDataTableDeleteRow(item) {
      this.modalDelete.solicitacaoSelecionada = item;
      this.modalDelete.closeModal = true;
    },

    deleteItemFromList(value) {
      this.modalCustomSize.actualEdit.listaDeItensRemovidos.push(this.modalCustomSize.actualEdit.listaDeItensSolicitados.filter((item) => item.numeroItemSistemaUnidade == value.numeroItemSistemaUnidade)[0]);
      this.modalCustomSize.actualEdit.listaDeItensSolicitados = this.modalCustomSize.actualEdit.listaDeItensSolicitados.filter((item) => item.numeroItemSistemaUnidade != value.numeroItemSistemaUnidade);

      if (this.modalCustomSize.actualEdit.listaDeItensSolicitados.length == 0) {
        this.modalCustomSize.isButtonsDisabled = true;
      }
    },

    verifyIfExist(nomeDoItem, solicitacoesAnteriores) {
      let cor = "green";

      if (solicitacoesAnteriores.length > 0) {
        solicitacoesAnteriores.map((solicitacaoSelecionada) => {
          const itensVerificados = solicitacaoSelecionada.itensSolicitados.filter((itemSelecionado) => itemSelecionado.nomeItemSistema == nomeDoItem);

          if (itensVerificados.length > 0) {
            cor = "red";
          }
        });
      }

      return cor;
    },

    _formatStringInBrazilianDateFormat(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
        return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
      } else {
        return "Sem Data!";
      }
    },

    retornarMes(qtSubtrair) {
      const dataAtual = new Intl.DateTimeFormat('default', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
          timeZone: 'America/Sao_Paulo'
      }).format(new Date()).replace(/,/g, '');

      var data  = dataAtual.split(" ")[0];
      var mes  = data.split("/")[1];

      return this.formataMes(parseInt(mes) - qtSubtrair);
    },

    formataMes(mes) {
      switch (mes) {
        case 1:
          return "Janeiro";
        case 2:
          return "Fevereiro";
        case 3:
          return "Março";
        case 4:
          return "Abril";
        case 5:
          return "Maio";
        case 6:
          return "Junho";
        case 7:
          return "Julho";
        case 8:
          return "Agosto";
        case 9:
          return "Setembro";
        case 10:
          return "Outubro";
        case 11:
          return "Novembro";
        case 12:
          return "Dezembro";
      }
    },

    verificaUnidade(numeroUnidade) {
      switch (numeroUnidade) {
        case 67:
          return true;
        case 66:
          return true;
        case '67':
          return true;
        case '66':
          return true;
        default:
          return false;
      }
    },

    retornaNumeroUnidadeZSaude(numeroUnidade) {
      switch (numeroUnidade) {
        case 67:
          return 10;
        case 66:
          return 11;
        case '67':
          return 10;
        case '66':
          return 11;
      }
    },

    formatarQuantidade(quantidade) {
      if (quantidade) {
        return quantidade;
      } else {
        return "Sem Quantidade no Estoque";
      }
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
